import React from 'react';
import PropTypes from 'prop-types';
import LoginHeader from '../../LoginHeader/LoginHeader';
import LoginFooter from '../LoginFooter/LoginFooter';
import { ApolloConsumer } from 'react-apollo';
import MeetingQueries from '../../../graphql-operations/meetings.graphql';
import ErrorHandlingService from '../../../services/error-handling.service';


const createMeetingAndNav = ($event, meeting, client, handleErrorNav, handleSuccessNav) => {
    $event.preventDefault();
    const { advisorId, advisorRequested, additionalInformation, preferredPhoneNumber, reasonId, roomId, studentId } = meeting;
    client.mutate({
        mutation: MeetingQueries.MEETINGS_MUTATION,
        variables: { advisorId, advisorRequested, additionalInformation, preferredPhoneNumber, reasonId, roomId, studentId },
    })
    .then(handleSuccessNav)
    .catch(error => {
        ErrorHandlingService.handleException(error);
        handleErrorNav();
    });
};

const handleAdvisorOptionChange = (advisor, meeting) => {
    if (!advisor) Object.assign(meeting, { advisorId: null, advisorRequested: 'First Available' });
    else {
        advisor = JSON.parse(advisor);
        Object.assign(meeting, { advisorId: advisor.id, advisorRequested: advisor.name });
    }
};

let changeDebounceTimeout; // lodash debouncing doesn't play well with React synthetic events, but this easily accomplishes the same thing
const handleAdditionalInformationChange = (newValue, meeting) => {
    clearTimeout(changeDebounceTimeout);
    changeDebounceTimeout = setTimeout(() => Object.assign(meeting, { additionalInformation: newValue }), 500);
};

const VisitForm = ({ handleErrorNav, handleSuccessNav, meeting, room }) => {
    return (
        <ApolloConsumer>
        {client => (
            <div className="grid-y medium-grid-frame">
                <div className="grid-x medium-grid-frame">
                    <section className="cell">
                        <form onSubmit={$event => createMeetingAndNav($event, meeting, client, handleErrorNav, handleSuccessNav)} className="grid-y medium-grid-frame grid-padding-x tx-kiosk__content">
                            <LoginHeader title="Why are you here?" />
                            <div className="cell auto cell-block-container">
                                <div className="cell auto cell-block-container cell-block-y tx-kiosk__form">
                                    <label>
                                        <div className="tx-label tx-label--required">Reason for your visit</div>
                                        <select className="tx-select" defaultValue="" aria-label="Choose Reason" required onChange={({ target }) => Object.assign(meeting, { reasonId: target.value })}>
                                            <option disabled value="">Choose One</option>
                                            {room && room.meetingReasons ? room.meetingReasons.map(reason => <option key={reason.id} value={reason.id}>{reason.shortName}</option>) : ''}
                                        </select>
                                    </label>
                                    <label>
                                        <div className="tx-label tx-label--required">Request a Counselor</div>
                                        <select className="tx-select" aria-label="Select Counselor" onChange={({ target }) => handleAdvisorOptionChange(target.value, meeting)}>
                                            <option default value="">First Available</option>
                                            {room && room.advisorOptions ? room.advisorOptions.map(advisor => <option key={advisor.id} value={JSON.stringify(advisor)}>{advisor.name}</option>) : ''}
                                        </select>
                                    </label>
                                    <label>
                                        <div className="tx-label">Additional Information</div>
                                        <textarea
                                            className="tx-input"
                                            name="addnl-info"
                                            type="text"
                                            aria-label="Additional Information"
                                            onChange={({ target }) => handleAdditionalInformationChange(target.value, meeting)}
                                            placeholder="Is there anything else you would like to tell us?" />
                                    </label>
                                </div>
                            </div>
                            <LoginFooter buttonText="Check In" type="submit" />
                        </form>
                    </section>
                </div>
            </div>
        )}
        </ApolloConsumer>
    );
};

export default VisitForm;

VisitForm.propTypes = {
    handleErrorNav: PropTypes.func,
    handleSuccessNav: PropTypes.func,
    meeting: PropTypes.any,
    room: PropTypes.any,
};



// WEBPACK FOOTER //
// ./src/components/login-flow-components/VisitForm/VisitForm.jsx